module.exports = __webpack_public_path__ + "img/2017-usopencup.f6d2d28e.jpg";